// PlanCard.js
import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Button,
  Text,
  Divider,
  Page,
  Banner,
  Modal,
  Spinner,
} from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
// import { Modal } from '@shopify/app-bridge/actions';
// import { useAppBridge } from '@shopify/app-bridge-react';

function PlanCard() {
  // const shopify = useAppBridge(); // Get the App Bridge instance
  // const redirect = Redirect.create(appBridge);
  const navigate = useNavigate();
  const [planActive, setPlanActive] = useState(false);
  const [request, setRequest] = useState(true);
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const url = new URL(window.location.href);
    const shopParts = url.pathname.split("/"); // Split path by '/'

    const shopFromUrl = shopParts[4]; // Extract shop name or set to null

    // Append .myshopify.com if necessary
    const fullShop = `${shopFromUrl}.myshopify.com`;
    const shop = urlParams.get("shop") || fullShop;
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/shopify/plan?shop=${shop}`)
      .then((result) => {
        let response = result.data;
        console.log("Result", result);
        if (response.data && response.data.status == "ACTIVE") {
          setPlanActive(true);
          setRequest(false);
          setTimeout(() => {
            setMainLoader(false);
          }, 2000);
        } else {
          setPlanActive(false);
          setRequest(false);
          setTimeout(() => {
            setMainLoader(false);
          }, 2000);
        }
      })
      .catch((error) => {
        setRequest(false);
        console.error(error);
        setTimeout(() => {
          setMainLoader(false);
        }, 2000);
      });
  }, []);
  const [loader, setLoader] = useState(false);
  const [mainLoader, setMainLoader] = useState(true);
  const [btnDisable, setBtnDisable] = useState(false);
  const [warnings, setWarnings] = useState({
    disabled: false,
    message: "",
    tone: "warning",
  });
  const [cancelPlanModal, setCancelPlanModal] = useState(false);
  const ref = useRef(null);
  const handleClick = () => {
    setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: "smooth" });
      setTimeout(() => {
        setWarnings({ disabled: false, message: "", tone: "" });
      }, 3000);
    }, 500);
  };

  const handlPurchase = async () => {
    setLoader(true);
    const name = "Premium Monthly Plan";
    const price = 9.99;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const shop = urlParams.get("shop");
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/shopify/plan/purchase?shop=${shop}`,
        {
          name,
          price,
          shop,
        }
      )
      .then((response) => {
        const data = response.data;
        console.log("Data saved successfully:", data);
        setLoader(false);
        setBtnDisable(true);
        window.top.location.href = data.url;
        // redirect.dispatch(Redirect.Action.REMOTE, data.url);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoader(false);
        const errorMessage =
          error.response?.status === 404
            ? "Store Not found"
            : "Something went wrong";

        setWarnings({
          disabled: true,
          message: errorMessage,
          tone: "warning",
        });
        handleClick();
      });
  };

  const handlePurchasCancel = async () => {
    setCancelPlanModal(false);
    setLoader(true);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const shop = urlParams.get("shop");
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/api/shopify/plan/cancel?shop=${shop}`
      )
      .then((response) => {
        const data = response.data;
        console.log("Data saved successfully:", data);
        setBtnDisable(false);
        setPlanActive(false);
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoader(false);
        const errorMessage =
          error.response?.status === 404
            ? "Store Not found"
            : "Something went wrong";

        setWarnings({
          disabled: true,
          message: errorMessage,
          tone: "warning",
        });
        handleClick();
      });
  };
  if (mainLoader) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          position: "relative",
          top: "150px",
        }}
      >
        <Spinner accessibilityLabel="Spinner example" size="large" />
      </div>
    );
  }
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Page narrowWidth={true}>
        {warnings.disabled && (
          <div ref={ref}>
            <Banner
              title={warnings.message}
              tone={warnings.tone}
              onDismiss={() =>
                setWarnings({ disabled: false, message: "", tone: "info" })
              }
            />
          </div>
        )}
        <Card
          sectioned
          style={{
            maxWidth: "400px",
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Gradient Header */}
          <div className="plan-box--style">
            <Text variant="headingLg" as="h2" fontWeight="bold">
              PREMIUM
            </Text>
            <Text variant="bodyLg" as="h2" fontWeight="regular">
              Monthly Plan
            </Text>
          </div>

          {/* Price Section */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "20px 0",
            }}
          >
            <Text variant="heading2xl" as="h3" fontWeight="bold">
              $9.99
            </Text>
            <Text as="p" variant="bodyMd" color="subdued">
              USD/Month <br /> Billed Monthly
            </Text>
          </div>

          <Divider />

          {/* Feature List */}
          <div style={{ padding: "20px 0" }}>
            <Text variant="headingMd" as="h3" fontWeight="bold">
              Standout Features
            </Text>
            <ul
              style={{ listStyleType: "none", padding: 0, marginTop: "10px" }}
            >
              {[
                "Order Amount Threshold Reward",
                "First Order Reward",
                "Signup Store Reward",
                "Referral Reward",
                "Seasonal Promotions Reward",
              ].map((feature, index) => (
                <li
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <span
                    style={{
                      color: "#28a745",
                      fontSize: "1.2em",
                      marginRight: "8px",
                    }}
                  >
                    ✓
                  </span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Button Section */}
          <div style={{ padding: "20px 0", textAlign: "center" }}>
            {request ? (
              <Spinner
                accessibilityLabel="Small spinner example"
                size="small"
              />
            ) : !planActive ? (
              <Button
                disabled={btnDisable}
                loading={loader}
                onClick={handlPurchase}
                primary
                fullWidth
                size="large"
                variant="primary"
              >
                Select Plan
              </Button>
            ) : (
              <>
                <div style={{ marginBottom: "5px" }}>
                  <Button
                    disabled={true}
                    primary
                    fullWidth
                    size="large"
                    tone="success"
                    variant="primary"
                  >
                    Plan Is Active
                  </Button>
                </div>
                <Button
                  disabled={btnDisable}
                  loading={loader}
                  onClick={() => setCancelPlanModal(true)}
                  primary
                  fullWidth
                  size="large"
                  tone="critical"
                  variant="primary"
                >
                  Cancel Plan
                </Button>
                <Modal
                  open={cancelPlanModal}
                  onClose={() => setCancelPlanModal(false)}
                  title="Are you sure you want to cancel the Subscription/Plan?"
                  primaryAction={{
                    content: "Yes",
                    onAction: () => handlePurchasCancel(),
                  }}
                  secondaryActions={[
                    {
                      content: "No",
                      onAction: () => setCancelPlanModal(false),
                    },
                  ]}
                />
              </>
            )}
          </div>
          <Divider />
        </Card>
      </Page>
    </div>
  );
}

export default PlanCard;
